<template>
  <div class="main_center lawEnforcementList">
    <div class="content">
        <div class="search-content">
            <div class="mainBtn">
                <el-button @click="routerAdd" size="small" type="primary" v-if="hasBtnPermission('btn_bid_check_configurationItem_add')">新增</el-button>
            </div>
            <div class="searchBtn" >
              
                <span class="label-form">检查内容：</span>
                <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 200px" v-model="form.content"></el-input>
                <span class="label-form">检查环节：</span>
                <el-select clearable style="width:150px;display: inline-block;" v-model="form.type">
                    <el-option :value="1" label="开标"></el-option>
                    <el-option :value="2" label="评标"></el-option>
                </el-select>
                <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
                <!--                <el-button size="mini" type="text" @click="moreSearchItem = true" icon="el-icon-arrow-down">更多搜索</el-button>-->
                <el-divider direction="vertical"></el-divider>
                <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
            </div>
        </div>

      <template v-if="addDialog">
        <bidCheckConfigItem-detail ref="bidCheckConfigItem" @handleClose="handleClose"></bidCheckConfigItem-detail>
      </template>

      <el-table :data="tableData"
                :header-cell-style="this.$globalGrayTableHeaderStyle"
                :height="tableMaxHeight"
                border
                class="table-content"
                ref="multipleTable"
                stripe v-loading="dataListLoading">
        <el-table-column fixed type="selection" v-if="hasBtnPermission('btn_bid_check_configurationItem_del')" align="center"></el-table-column>
        <el-table-column fixed label="序号" type="index"  width="50" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="启用状态" align="center" width="100">
          <template slot-scope="scope">
                <span style="display: inline-block;position: relative">
                    <el-switch
                            v-model="scope.row.status"
                            :width="50"
                            @change="(val)=>updateStatus(val,scope.row)"
                            active-color="#1890FF"
                            inactive-color="rgba(0, 0, 0, 0.25)">
                    </el-switch>
                    <span :class="scope.row.status?'switch-active':'switch-inactive'" @click="updateStatus(scope.row)" class="switch-text">{{scope.row.status?'开启':'关闭'}}</span>
                </span>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small"  v-if="hasBtnPermission('btn_bid_check_configurationItem_add')" @click="router(scope.row)">修改</el-button>
            <el-button type="text" size="small" title="删除" v-if="hasBtnPermission('btn_bid_check_configurationItem_del')" @click="deleteById(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column label="检查编码" prop='code' header-align="center" align="center" width='150'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="检查环节" prop='type' header-align="center" align="center" width='100'
                         :show-overflow-tooltip='true'>
            <template slot-scope="scope">
                <span>{{scope.row.type == '1'?'开标':'评标'}}</span>
            </template>
        </el-table-column>
        <el-table-column label="检查内容" prop='content' header-align="center" align="left" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="创建日期" prop='createTime' header-align="center" align="center" width='170'
                         :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
      <paginationCom  @sizechange="sizeChangeHandle" @pagechange="pageChangeHandle" class="limit" :options="paginationOpt"></paginationCom>
    </div>
  </div>
</template>

<script>
    import { mapState } from "vuex";
    import bidCheckConfigItem_detail from './bid_check_config_detail.vue'
    import {syscheckitemconfigList,syscheckitemconfigDelete,updateStatusById} from '@/server/bidCheckConfigItem'
    export default {
    components:{
      'bidCheckConfigItem-detail':bidCheckConfigItem_detail
    },
    data(){
      return {
        tableMaxHeight: document.documentElement.clientHeight - 237 ,
        dataListLoading: false,
        form: {
          content:null,
          type:null,
          tradeId:''
        },
        moreSearchItem: false,
        paginationOpt:{
          pageIndex:1,
          pageSize:10,
          total:0,
          pageSizes:[10,20,50]
        },
        tableData: [{},{}],
        addDialog:false,
      }
    },
    activated(){
      this.getData()
    },

    computed:{
      ...mapState({
        isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}
    }),
    },
    mounted() {
        const that = this;
        let resizeTag = true;
        window.onresize = () => {
            if(resizeTag) { //防抖动
                that.ifmove();
                    resizeTag = false
                setTimeout(() => {
                    resizeTag = true
                }, 1000)
            }
        }
        that.ifmove();
    },
    methods:{

        updateStatus(val,data){

            var status = data?val:!val.status;
            var id = data?data.id:val.id;
            updateStatusById({id:id,status:status}).then(res => {
                if (res.data.code == '1') {
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    })
                    this.getData();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            })

        },

        ifmove() {
             // let hasBtnPermisson = this.hasBtnPermission('btn_bid_check_configurationItem_add');
             let tableMaxHeight = document.documentElement.clientHeight - 237 ;
             this.paginationOpt.pageSize= parseInt((tableMaxHeight) / 50 ) || 1;
             this.$nextTick(() => {
                 this.tableMaxHeight = tableMaxHeight
             })
           
        },
        getData() { // 获取列表数据
          this.dataListLoading=true;
          syscheckitemconfigList({
            'page': this.paginationOpt.pageIndex,
            'rows': this.paginationOpt.pageSize,
            "searchKey":this.form.content,
            'filter':{
                type:this.form.type||null,
                tradeId:this.form.tradeId||null
            }
          }).then(res => {
            this.tableData = res.data.rows;
            this.paginationOpt.total = res.data.total;
            this.$refs.multipleTable.doLayout();
          }).finally(()=>{this.dataListLoading = false})
        },
        // 每页长度改变
        sizeChangeHandle(value){
          this.paginationOpt.pageSize=value;
          this.paginationOpt.pageIndex=1;
          this.getData();
        },
        // 当前页改变
        pageChangeHandle(value){
          this.paginationOpt.pageIndex = value;
          this.getData();
        },
        indexMethod(index) {
            return (this.paginationOpt.pageSize - 1) * Number(this.paginationOpt.pageSize) + Number(index) + 1
        },
        //搜索按钮
        searchBtn(){
            this.paginationOpt.pageIndex = 1;
            this.getData();
        },
        refresh() {//刷新按钮
          this.paginationOpt.pageIndex = 1;
          Object.assign(this.$data.form, this.$options.data().form)
          this.getData();
        },
        routerAdd(){//新增页面
          this.title="新增配置项"
          this.addDialog=true;
          this.$nextTick(res=>{
            this.$refs.bidCheckConfigItem.dialogVisible=true;
          });
        },
        handleClose(){//关闭弹框
          this.addDialog=false;
          this.getData();
        },
        router(item){ // 跳转详情
          var id =item? item.id:0;
          this.routerAdd();
          this.$nextTick(res=>{
            this.$refs.bidCheckConfigItem.getSingle(id);
          });
          
        },
        deleteById(item) {
          this.$confirm(`确定要删除该数据?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            syscheckitemconfigDelete({id:item.id}).then(res => {
              if (res.data.code == '1') {
                this.$message({
                  type: 'success',
                  message: res.data.msg
                })
                this.getData();
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.msg
                })
              }
            })
          })
        },
    },

    destroyed(){
      window.onresize = null;
    },




}
</script>
<style lang="scss" scoped>

    //列表页面
    .main_center{
      .switch-text{
        font-size: 12px;
          cursor: pointer;
        position: absolute;
        color: rgba(255, 255, 255, 1);
        line-height: 24px;
      }
      .switch-active{
          left:7px;
      }
      .switch-inactive{
          right:7px;
      }

    }

</style>
